<template>
  <div id="page">
    <b-container style="margin-top: 1rem;">
      <div class="cardOriGroup">
        <div>
          <input id="ori_h" type="radio" v-model="cardOri" name="cardOriRd" value="0"></input>
          <label for="ori_h">横版</label>
          /
          <input id="ori_v" type="radio" v-model="cardOri" name="cardOriRd" value="1"></input>
          <label for="ori_v">竖版</label>
        </div>
      </div>

      <div>
        <b-row>
          <b-col cols="6" class="mx-auto text-center py-2" @click="selectCardface()">
            <b-img src="/static/uploadhor.png"></b-img>
            <p>点此上传图片</p>
          </b-col>
        </b-row>
      </div>

      <div style="margin-top: 32px; text-align: left;">
        <h5>上传须知</h5>
        <ol>
          <li>图片最小分辨率为{{pxLimit}}像素，最大为10MB</li>
          <li>涉黄、涉暴、涉政等违规图片将无法审核通过</li>
          <li>上传图片须为宠物图片，否则将无法审核通过</li>
        </ol>
      </div>

      <b-modal ok-only ref="model_error" title="提示" @ok="handleOk" ok-title="确定">
        <p class="my-4">{{errorMsg}}</p>
      </b-modal>
    </b-container>

  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  import axios from 'axios'
  export default {
    name: 'SelectCardface',
    data() {
      return {
        bankSerialNumber: '',
        bankCode: '',
        selectParam: null,
        cardOri: 0,
        pxLimit: "1075 * 686",
        imgWlimit: 1075,
        imgHlimit: 686,
        imgSizeLimit: 10 * 1024 * 1024,
        errorMsg: '',
        cardTheme: '',
      }
    },
    watch: {
      cardOri: function(newval, oldval) {
        console.log("当前版面方向：" + newval, "之前版面方向：" + oldval);
        if (newval == 0) {
          this.imgWlimit = 1075;
          this.imgHlimit = 686;
        } else if (newval == 1) {
          this.imgWlimit = 686;
          this.imgHlimit = 1075;
        }
        this.pxLimit = this.imgWlimit + "*" + this.imgHlimit;
      }
    },
    methods: {
      handleOk: function(bvModalEvt) {

      },
      showErrorMsg: function() {
        this.$refs['model_error'].show();
      },
      hideErrorMsg: function() {
        this.$refs['model_error'].hide();
      },
      selectCardface: function() {
        var that = this;
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function(res) {
            console.log(res);
            var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            var faceImgPath = localIds[0];
            console.log('imgPath:' + faceImgPath);
            that.checkImg(faceImgPath);
          },
        });
      },
      checkImg: function(imgPath) {
        let that = this;
        wx.getLocalImgData({
          localId: imgPath, // 图片的localID
          success: function(res) {
            var localData = res.localData;
            if (localData.indexOf('data:image') != 0) {
              //判断是否有这样的头部
              localData = 'data:image/jpeg;base64,' + localData
            }
            localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg')
            //第一个替换的是换行符，第二个替换的是图片类型，因为在IOS机上测试时看到它的图片类型时jgp，
            //这不知道时什么格式的图片，为了兼容其他设备就把它转为jpeg

            let image = new Image();
            let w, h;
            image.src = localData;
            // 如果有缓存，读缓存
            if (image.complete) {
              w = image.width; // 图片宽度
              h = image.height; // 图片高度
            } else { //否则加载图片
              image.onload = function() {
                w = image.width; // 图片宽度
                h = image.height; // 图片高度
                image.onload = null; // 避免重复加载
                if (w > that.imgWlimit && h > that.imgHlimit) {
                  let imgSize = that.getImgSize(localData);
                  console.log("图片宽高:" + +w + "*" + h);
                  console.log("图片大小:" + (imgSize / 1024) + "KB");
                  if (imgSize > that.imgSizeLimit) {
                    that.errorMsg = "图片大小不能超过10MB";
                    that.showErrorMsg();
                  } else {
                    that.toEditCardface(imgPath);
                  }
                } else {
                  that.errorMsg = "图片像素不符合要求，图片的像素：" + w + "*" + h
                  that.showErrorMsg();
                }
              };
            }
          }
        });

      },
      getImgSize: function(imgBase64) {
        //1.需要计算文件流大小，首先把头部的data:image/png;base64,（注意有逗号）去掉。
        var str = imgBase64.split(",")[1];
        //2.找到等号，把等号也去掉
        var equalIndex = str.indexOf('=');
        if (str.indexOf('=') > 0) {
          str = str.substring(0, equalIndex);
        }
        //3.原来的字符流大小，单位为字节
        var strLength = str.length;
        //4.计算后得到的文件流大小，单位为字节
        var fileLength = parseInt(strLength - (strLength / 8) * 2);
        return fileLength;
      },
      toEditCardface: function(imgPath) {
        var selectParam = JSON.stringify(this.selectParam)
        let cardThemeParam = JSON.stringify(this.cardTheme);
        this.$router.replace({
          name: 'EditCardface',
          params: {
            imagePath: imgPath,
            bankSerialNumber: this.bankSerialNumber,
            bankCode: this.bankCode,
            selectParam: selectParam,
            cardOri: this.cardOri,
            cardTheme: cardThemeParam
          }
        });
      },

      wxJsSdk: function() {
        var url = window.location.href.split('#')[0];
        console.log(url);
        var formData = new FormData()
        formData.append('shareUrl', url);
        for (var [a, b] of formData.entries()) {
          console.log(a, b);
        }
        //url: 'http://127.0.0.1:8081/initWXJSSDKConfigInfo',
        //url: 'https://cp.hengbao.net.cn/pay/order/wx/initWXJSSDKConfigInfo',
        axios({
            method: 'post',
            url: 'https://cp.hengbao.net.cn/pay/order/wx/initWXJSSDKConfigInfo',
            data: formData,
          }).then(function(response) {
            var data = response.data
            console.log(data.appid);
            console.log(response.data);
            console.log(response.status);
            console.log(response.statusText);
            console.log(response.headers);
            console.log(response.config);

            /* {
              signature: "1ba9d96ab3b38bb34037b46d5714d61b659d3031",
              appid: "wxecacb5516c17832b",
              jsapi_ticket: "kgt8ON7yVITDhtdwci0qeR5ZO1LunrcgBtLGj8xD8npFwV-6wRlIWdgjZMmuTynPLmFHHz7E30LFBGwzmBtLOg",
              nonceStr: "6024281b-1600-4960-81b6-87876c9203b4",
              timestamp: "1589963929"
            } */

            wx.config({
              debug: false,
              appId: data.appid,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: [
                'chooseImage',
                'getLocalImgData',
              ]
            });
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    mounted: function() {
      this.wxJsSdk()
      // this.bankSerialNumber = this.$route.params.bankSerialNumber;
      // console.log("bankSerialNumber:" + this.bankSerialNumber);

      this.bankSerialNumber = this.$route.query.bankSerialNumber
      console.log("bankSerialNumber:" + this.bankSerialNumber);
      this.bankCode = this.$route.query.bankCode;
      console.log("bankCode:" + this.bankCode);
      var selectParam = this.$route.params.selectParam;
      console.log('selectParam:' + selectParam)
      if (selectParam != undefined) {
        this.selectParam = JSON.parse(selectParam)
      }

      console.log("this.selectParam:" + this.selectParam);

      let themeParam = this.$route.params.cardTheme;
      console.log('themeParam:' + themeParam)
      if (themeParam !== undefined) {
        this.cardTheme = JSON.parse(themeParam)
      }
    }
  }
</script>

<style scoped>
  .cardOriGroup {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    align-items: flex-end;
    height: 64px;
  }

  .cardOriGroup input {
    display: none;
  }

  .cardOriGroup label {
    color: gray;
    line-height: 28px;
    min-width: 20vw;
    min-height: 28px;
    text-align: center;
    border-radius: 4px;
    margin: 8px;
  }

  .cardOriGroup input:checked+label {
    background-size: 21px 21px;
    font-weight: bold;
    color: black;
    margin: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectCardface.vue